import { autoinject } from 'aurelia-framework';
import { PenOrderItem } from 'models/pen/PenOrderItem';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class PenOrderItemService extends BaseApiService<PenOrderItem> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, PenOrderItem);
  }
}
